<template>
  <BaseVeeForm :action="syncAudience" v-slot="formProps">
    <ValidationProvider name="audience" slim vid="audience_id" rules="required">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormInput type="hidden" v-model="formData.audience_id" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>
    <BaseButton
      primary
      outline
      small
      class="flex items-center"
      :disabled="hasUnhandledError || formProps.isPending"
    >
      <span>{{ hasUnhandledError ? 'Error' : 'Sync' }}</span>
    </BaseButton>
  </BaseVeeForm>
</template>

<script>
import { syncedAudiencesClient } from '@/api/clients';

export default {
  props: {
    audience: {
      type: Object,
      required: true,
    },
    onSynced: {
      type: Function,
      default: () => {
        //
      },
    },
  },
  data() {
    return {
      formData: {
        audience_id: this.audience.id,
      },
      hasUnhandledError: false,
    };
  },
  methods: {
    async syncAudience() {
      try {
        const response = await syncedAudiencesClient.store(this.formData);

        this.onSynced(response.data);

        return Promise.resolve();
      } catch (error) {
        if (error?.response?.status !== 422) {
          this.hasUnhandledError = true;
        }
        return Promise.reject(error);
      }
    },
  },
};
</script>
